import styled, { css } from "styled-components";
import { Link as ScrollLink } from "react-scroll";

import bgSrcMobile from "../../assets/bg2025_mobile@2x.jpg";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  inset: 0;
  background-image: url(${bgSrcMobile});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: center;
  z-index: 100;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 104px;
  padding: 12px 24px;
`;

export const Logo = styled.img`
  flex-shrink: 0;
  width: 80px;
`;

export const MenuButton = styled.button`
  width: 48px;
  height: 48px;
  padding: 0;
  color: #fff;
`;

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  padding: 16px 24px 40px;
`;

export const MenuContainer = styled.nav`
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  row-gap: 8px;
`;

const styledLink = css`
  color: #c3c3c3;
  font-family: "YWFT Ultramagnetic";
  font-size: 56px;
  line-height: 56px;
  text-align: right;
  text-transform: uppercase;
  cursor: pointer;

  &:hover,
  &.--active {
    color: #fff;
  }
`;

export const Link = styled(ScrollLink)`
  ${styledLink}

  @media (min-width: 1024px) {
    &.--active {
      box-shadow: 0 4px 0 0 #dc9b00;
    }
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 32px;
`;

export const SocialContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 24px;
`;

export const SocialLink = styled.a`
  width: 32px;
  height: 32px;
  color: #fff;
  font-size: 32px;
`;
